import { apiClient } from './client';
import type { AutoAssignRule } from '../types';

export const autoAssignApi = {
  list: async () => {
    const res = await apiClient.get('/auto-assign');
    return res.data.data.rules as AutoAssignRule[];
  },

  create: async (data: Partial<AutoAssignRule>) => {
    const res = await apiClient.post('/auto-assign', data);
    return res.data.data.rule as AutoAssignRule;
  },

  update: async (id: string, data: Partial<AutoAssignRule>) => {
    const res = await apiClient.put(`/auto-assign/${id}`, data);
    return res.data.data.rule as AutoAssignRule;
  },

  delete: async (id: string) => {
    await apiClient.delete(`/auto-assign/${id}`);
  },
};
